import { Tower } from './Tower';
import { Monster } from '../monsters/Monster';
import { SoundEffect } from '../../systems/AudioManager';

export class MultiDirectionalTower extends Tower {
  constructor(scene: Phaser.Scene, x: number, y: number) {
    // damage: 15, attackSpeed: 1.5, range: 130 - shoots in 4 directions
    super(scene, x, y, 15, 1.5, 130);
    
    this.removeAll();
    this.createMultiDirectionalVisuals();
  }

  protected override createVisuals(): void {
    // Create base
    const base = this.scene.add.circle(0, 0, 20, 0x440044);
    this.add(base);
    
    // Create 4 directional cannons
    const cannon1 = this.scene.add.rectangle(0, -15, 6, 20, 0x880088); // North
    const cannon2 = this.scene.add.rectangle(15, 0, 20, 6, 0x880088);  // East
    const cannon3 = this.scene.add.rectangle(0, 15, 6, 20, 0x880088);  // South
    const cannon4 = this.scene.add.rectangle(-15, 0, 20, 6, 0x880088); // West
    
    this.add([cannon1, cannon2, cannon3, cannon4]);
  }

  private createMultiDirectionalVisuals(): void {
    this.createVisuals();
  }

  protected override attack(target: Monster): void {
    this.audioManager.playSFX(SoundEffect.TOWER_SHOOT);
    // Fire in all 4 directions instead of just at target
    const directions = [
      { x: 0, y: -1 },   // North
      { x: 1, y: 0 },    // East
      { x: 0, y: 1 },    // South
      { x: -1, y: 0 }    // West
    ];

    directions.forEach(dir => {
      this.fireInDirection(dir.x, dir.y);
    });
  }

  private fireInDirection(dirX: number, dirY: number): void {
    const projectile = this.scene.add.circle(this.x, this.y, 3, 0xff00ff);
    
    const targetX = this.x + dirX * this.effectiveRange;
    const targetY = this.y + dirY * this.effectiveRange;
    
    this.scene.tweens.add({
      targets: projectile,
      x: targetX,
      y: targetY,
      duration: 300,
      ease: 'Linear',
      onUpdate: () => {
        // Check for monster hits along the path
        if (this.scene && this.scene.children) {
          this.scene.children.list.forEach((child) => {
            if (child instanceof Monster && child.getIsActive()) {
              const distance = Phaser.Math.Distance.Between(projectile.x, projectile.y, child.x, child.y);
              if (distance <= 15) { // Hit radius
                child.takeDamage(this.effectiveDamage);
                projectile.destroy();
              }
            }
          });
        }
      },
      onComplete: () => {
        projectile.destroy();
      }
    });
  }
} 